import { render, staticRenderFns } from "./KommunetorgetUniversalPage.vue?vue&type=template&id=1226745c&"
import script from "./KommunetorgetUniversalPage.vue?vue&type=script&lang=js&"
export * from "./KommunetorgetUniversalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1226745c')) {
      api.createRecord('1226745c', component.options)
    } else {
      api.reload('1226745c', component.options)
    }
    module.hot.accept("./KommunetorgetUniversalPage.vue?vue&type=template&id=1226745c&", function () {
      api.rerender('1226745c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/KommunetorgetUniversalPage.vue"
export default component.exports